import { render, staticRenderFns } from "./Brain.vue?vue&type=template&id=78084c27&scoped=true&"
import script from "./Brain.vue?vue&type=script&lang=js&"
export * from "./Brain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78084c27",
  null
  
)

export default component.exports